module.exports = __webpack_public_path__ + "static/media/Beowulf.65c60bd4.jpg";